console.log('here');
jQuery(document).ready(function(){
  jQuery('.sidebar li').hover(function(){
    jQuery(this).siblings('li').removeClass('dev_activeParent');
    jQuery(this).addClass('dev_activeParent');
    var dev_parent = jQuery(this).attr('data-parent');
    
    jQuery('.submenu > div').each(function(){
      var dev_child = jQuery(this).attr('data-sub'); 
      if(dev_child == dev_parent){
          jQuery(this).addClass('dev_activeSub');
      }else{
          jQuery(this).removeClass('dev_activeSub');
      }
    });

    jQuery('.dev_menuContainer .image img').each(function(){
      var dev_childImg = jQuery(this).attr('data-img'); 
      if(dev_parent == dev_childImg){
          jQuery(this).addClass('dev_activeImg');
      }else{
          jQuery(this).removeClass('dev_activeImg');
      }
    });
    
  });
});